import React, { FC, memo } from 'react';
import { Text, View } from '@react-pdf/renderer';

import styles from '../pdfStyles';

type Props = {
    comment?: string;
};
const PdfComment: FC<Props> = (props: Props) => {
    const { comment } = props;

    if (!comment) {
        return <></>;
    }
    return (
        <View
            style={[
                styles.section,
                styles.borderRed2px,
                styles.width40Percent,
                styles.fontBold,
                styles.marginBottom10px,
                styles.padding2px4px
            ]}
            wrap={false}
        >
            <Text>{comment}</Text>
        </View>
    );
};

export default memo(PdfComment);
